const general = {
  action: {
    select: 'Seleccionar',
    returnToHome: 'Ir al Inicio',
    uploadTitle: 'Agregar documento firmado',
    uploadDescription: 'Arrastra y suelta aquí o haz clic para seleccionar',
  },
  feature: {
    attention: 'Atención',
    beta: 'Beta',
    test_beta_features: 'Prueba nuevas funcionalidades antes de su lanzamiento oficial.',
    unavailable_in_your_plan: 'Esta funcionalidad no está incluida en tu plan',
    more_info: 'Conoce más.',
  },
  errors: {
    restrictedFile: 'El documento tiene contraseña, no se pudo validar',
    unexpected: 'Ocurrió un error inesperado',
    invalidFile: 'Archivo inválido',
  },
};

export default general;
